var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTasksIcon = function SvgTasksIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "planner",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#264D6D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92 3.358h10.153c.506 0 .927-.42.927-.924a.934.934 0 0 0-.927-.925H8.92a.934.934 0 0 0-.927.925c0 .504.422.924.927.924ZM4.516.3l-2.08 2.262-.777-.845a.928.928 0 0 0-1.324-.043.917.917 0 0 0-.042 1.311l1.45 1.587c.168.19.42.296.672.296a.904.904 0 0 0 .672-.296l2.774-3.004A.917.917 0 0 0 5.82.257c-.357-.36-.946-.338-1.303.042ZM19.094 8.077H8.92a.934.934 0 0 0-.927.925c0 .504.422.924.927.924h10.154c.506 0 .927-.42.927-.924s-.4-.925-.906-.925ZM4.516 6.867l-2.08 2.264-.777-.846a.928.928 0 0 0-1.324-.043.917.917 0 0 0-.042 1.311l1.45 1.587c.168.19.42.296.672.296a.904.904 0 0 0 .672-.296l2.774-3.004a.917.917 0 0 0-.042-1.311c-.357-.36-.946-.339-1.303.042ZM19.094 14.645H8.92a.934.934 0 0 0-.927.925c0 .504.422.924.927.924h10.154c.506 0 .927-.42.927-.924s-.4-.925-.906-.925ZM4.49 13.417 2.406 15.69l-.78-.849a.93.93 0 0 0-1.327-.042c-.38.36-.4.955-.042 1.316l1.454 1.593a.906.906 0 0 0 .674.297.906.906 0 0 0 .674-.297l2.802-2.994a.921.921 0 0 0-.042-1.317.949.949 0 0 0-1.327.021Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTasksIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tasks_icon.35dc01bc.svg";
export { ForwardRef as ReactComponent };